export const workHubTabGroupColors = [
    { foreground: '#808080', background: '#FFFFFF' },
    { foreground: '#4682B4', background: '#D0EAFB' },
    { foreground: '#DC143C', background: '#FFE5E5' },
    { foreground: '#BFA40D', background: '#F7F4D9' },
    { foreground: '#157E15', background: '#CFF9D1' },
    { foreground: '#E11481', background: '#FFF0F2' },
    { foreground: '#BA55D3', background: '#FFEBFF' },
];
//# sourceMappingURL=consts.js.map